<template>
    <span>
        <div class="kce-site-header__svg" :class="{ menuOpen: isOpen }">
            <svg width="59" height="50" viewBox="0 0 59 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="21.377" width="59" height="6.413" rx="3.207" fill="#2E3192"></rect><rect y="35.272" width="59" height="6.413" rx="3.207" fill="#2E3192"></rect><rect y="7.482" width="59" height="6.413" rx="3.207" fill="#2E3192"></rect></svg>
        </div>
    </span>
</template>
<script>
    export default {
        props: ['isOpen'],
        created() {
            // console.log("Created! Hamburger Menu is open? - " + this.isOpen);
        },
        updated() {
            // console.log("Updated! Hamburger Menu is open? - " + this.isOpen);
        }
    }
</script>